import customerInfoBuilder from "@/apps/dashboard/buyback/core/infrastructure/mapper/buyback/customerInfo/customerInfoBuilder";
import { TemporaryCustomerInfos } from "@/apps/dashboard/buyback/core/infrastructure/repository/type/CustomerInfo/TemporaryCustomerInfos";

class TempCustomerInfosMapper {
  mapTempCustomerInfosFromString(stringCustomerInfos: string): TemporaryCustomerInfos {
    const parsedCustomerInfos = JSON.parse(stringCustomerInfos);

    const tempCustomerInfo = customerInfoBuilder.buildFromParsedCustomerInfo(parsedCustomerInfos.tempCustomerInfo);

    let tempCustomerIdentification = null;
    if (parsedCustomerInfos.tempCustomerIdentification) {
      tempCustomerIdentification = customerInfoBuilder.buildFromParsedCustomerIdentification(
        parsedCustomerInfos.tempCustomerIdentification
      );
    }

    return {
      tempCustomerInfo: tempCustomerInfo,
      tempCustomerIdentification: tempCustomerIdentification,
    };
  }

  mapTempCustomerInfosToString(tempCustomerInfos: TemporaryCustomerInfos): string {
    return JSON.stringify(tempCustomerInfos);
  }
}

export default new TempCustomerInfosMapper();
